import api from "../index";

export const GetAllTicketApi = (params) => api.get(`TicketMaster/GetTicketList-ByUserId?${params}`);
export const GetTicketPriorityApi = () => api.get('DropDown/Priority');
export const GetTicketQueryTypeApi = (params) => api.get(`DropDown/Ticket-Query?${params}`);
export const GenerateTicketApi = (data) => api.post('TicketMaster/Generate-Ticket', data);
export const GetTicketByIdApi = (params) => api.get(`TicketMaster/GetTicket-ByTicketId?${params}`);
export const GetTicketChatApi = (data) => api.post('TicketMaster/AddOrGet-ChatByTicketId', data);
export const UpdateTicketApi = (data) => api.post('TicketMaster/Update-Ticket', data);